// extracted by mini-css-extract-plugin
export default {"budgetTable":"BudgetTable_budgetTable__KheR+","totalRow":"BudgetTable_totalRow__ntZzt","ant-table-tbody":"BudgetTable_ant-table-tbody__XNYY9"};